import React from 'react';
import { connect } from 'react-redux';

import CancelSubscriptionCard from './CancelSubscriptionCard';

import { selectIsUserPaying } from '../../../../redux/auth/user/selectors';

const CancelSubscriptionCardConnected = (props) => <CancelSubscriptionCard {...props} />;

const mapStateToProps = (state) => ({
  isVisible: selectIsUserPaying(state),
});

export default connect(mapStateToProps)(CancelSubscriptionCardConnected);
